export const API_CONSTANTS = {
  fluAdmin: 'flu/api/admin',
  assessmentInstances: '/api/AssessmentInstances/',
  userProfile: 'assessments/api/UserProfile',
  comments: 'flu/api/QuestionnaireInstances/{questionaryId}/Comments',
  downloadFile: 'documents/api/public/documents/',
  exemptionRenewals: 'flu/api/ExemptionRenewals',
  questionnaireInstances: 'flu/api/QuestionnaireInstances',
  questionnaireInstancesStatuses: 'flu/api/FluShotVerificationStatuses',
  questionnaireInstancesSeasons: 'flu/api/CampaignSeasons',
  archivedQuestionnaireInstances: 'flu/api/ArchivedQuestionnaireInstances',
  programSummary: 'flu/api/ProgramSummary',
  sessionToken: 'token',
  sessionTimeout: 20 * 60 * 1000,
  uploadFile: 'flu/api/QuestionnaireInstances/{id}/Documents',
  userSessions: 'flu/api/UserSessions',
  additionalInfo: 'flu/api/QuestionnaireInstances/{questionaryId}/Messages',
  printFile: 'flu/api/public/receipt',
};
